// src/state/fittingRoomQueueStore.js
const KEY = "veya_fitting_room_queue_v1";
export const FITTING_QUEUE_CHANGED_EVENT = "veya:fitting_queue_changed";

function read() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]") || [];
  } catch {
    return [];
  }
}

function write(list) {
  localStorage.setItem(KEY, JSON.stringify(list || []));
  window.dispatchEvent(new Event(FITTING_QUEUE_CHANGED_EVENT));
}

export function listFittingQueue() {
  return read();
}

export function isInFittingQueue(productId) {
  return read().some((x) => x?.productId === productId);
}

export function addToFittingQueue(item) {
  if (!item?.id) return;

  const list = read();
  if (list.some((x) => x?.productId === item.id)) return;

  list.push({
    productId: item.id,
    createdAt: Date.now(),

    // Keep the full normalized catalog item so try_on/assets survive.
    item: {
      ...item,
    },
  });

  write(list);
}

export function removeFromFittingQueue(productId) {
  write(read().filter((x) => x?.productId !== productId));
}

export function clearFittingQueue() {
  write([]);
}